import ModelEntity from "../../../model-entity";
import {EntityType} from "../../../../gd/const/item";

export default class CrmContactSession extends ModelEntity {

    public firstName          : string | null
    public lastName           : string | null
    public email              : string | null
    public crmAccountId       : ID | null
    public contactType        : number | null
    public contactOwnerUserId : ID | null

    public userId             : ID | null
    
    
    constructor(data:any) {
        super(data['id'], EntityType.CRM_CONTACT)

        // this.id                 = data['id']

        this.firstName          = data['firstName']
        this.lastName           = data['lastName']
        this.email              = data['email']
        this.crmAccountId       = data['crmAccountId']
        this.contactType        = data['contactType']
        this.contactOwnerUserId = data['contactOwnerUserId']

        this.userId             = data['userId'] // not sure if it should be contactOwnerUserId ? i think it's a GD userId that linked to this contact

    }

    get name() {
        let res = '';
        if (this.firstName) res += this.firstName;
        if (this.lastName) res += ' ' + this.lastName;
        return res;
    }

    get fullName() {
        return this.name
    }
}
